import React from 'react';
import PropTypes from 'prop-types';
import { NotificationsWrapper } from 'sarsaparilla';

const IsGuidedQuestion = ({ contactAgency, handleAnswerChange }) => {
  return (
    <div>
      <div className="fieldset-question-wrap">
        <fieldset>
          <legend><strong>Is this a commercial guided trip? This can include an Outfitter, Guide, or pack Outfitter.</strong></legend>
          <div className="rec-form-inline-item-wrap">
            <div className="rec-form-inline-item">
              <label
                htmlFor="prompt-answer-yes1"
                className="rec-label-radio">
                <input
                  className="rec-input-hide"
                  type="radio"
                  value={'yes'}
                  id="prompt-answer-yes1"
                  name="prompt-answer-yesno1"
                  checked={contactAgency === 'yes'}
                  onChange={handleAnswerChange}
                  placeholder="Yes" />
                <span className="rec-input-radio" />
                Yes
              </label>
            </div>
            <div className="rec-form-inline-item">
              <label
                htmlFor="prompt-answer-no1"
                className="rec-label-radio">
                <input
                  className="rec-input-hide"
                  type="radio"
                  id="prompt-answer-no1"
                  name="prompt-answer-yesno1"
                  value={'no'}
                  checked={contactAgency === 'no'}
                  onChange={handleAnswerChange}
                  placeholder="No" />
                <span className="rec-input-radio" />
                No
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      {
        contactAgency === 'yes' &&
        <NotificationsWrapper noticeType="info" closeButton={false}>
          <p>You must contact the commercial operator providing those services. They will book the reservation for you.</p>
        </NotificationsWrapper>
      }
    </div>
  );
};

IsGuidedQuestion.propTypes = {
  contactAgency: PropTypes.string,
  handleAnswerChange: PropTypes.func.isRequired
};

export default IsGuidedQuestion;
